<div>
  <p class="d-none">
    <span class="sub-total" translate>CART_SUBTOTAL</span>:
    <span class="highlight">{{ totals.totalValue | gungCurrency: currencyCode:'symbol-narrow':'1.2-2' }}</span>
  </p>
</div>
